import React, { useCallback, useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import * as Yup from "yup";
import { useFormik } from "formik";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useNavigate } from "react-router-dom";
import { Button } from "../../common/Button";
import { failed, success } from "../../common/Toastify";
import { decryptData, encryptData } from "../../EncryptDecrypt";
import {
  typeOptions,
  createAccountOptions,
  FormikObjCreate,
  relationsList,
  createBasicFields,
  createBasicFieldsPractionerTwo,
} from "./Constants";
import { countryList, caregions, usregions } from "../../../utils/constants";
import { useOrgQuery } from "../../../hooks/ReactQueryHooks/useOrgQuery";
import MultiSelect from "../../common/textfield/MultiSelect";
import { Skeleton, Tooltip } from "@mui/material";
import {
  createKioskDevice,
  createUser,
  getCustomRoles,
  getPractitionerData,
  getPractitionerList,
  updateAgentId,
} from "../../api/Individual";
import FilterSelect from "../../common/textfield/FilterSelect";
import { useClinicLocationsQuery } from "../../../hooks/ReactQueryHooks/useClinicLocationsQuery";
import { Clear } from "@mui/icons-material";
import moment from "moment";
import {
  createContactNumber,
  formattedPhoneNumberLength,
} from "../../../utils/phoneNumberSupport";
import { useSelector } from "react-redux";
import Fields from "./Fields";
import { getDiscover, getOrganization, getOrganizationSettings } from "../../api/Organization";
import { validation, conditionalValidation } from "../../../utils/constants";

function CreateEmployee() {
  const navigate = useNavigate();
  const onSuccessLocations = (data) => {
    setLocations(
      data?.map((location) => (location = { ...location, value: location?.id }))
    );
  };
  useClinicLocationsQuery({ onSuccess: onSuccessLocations });
  const [locations, setLocations] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [organizations, setOrganizations] = useState([]);
  const [organizationsData, setOrganizationsData] = useState([]);
  const [rolesOptions, setRolesOptions] = useState([{ name: "-----" }]);
  const [regionOptions, setRegionOptions] = useState([]);
  const [roleSelected, setRoleSelected] = useState(false);
  const [orgSelected, setOrgSelected] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState(null);
  const [loading, setLoading] = useState(false);

  const [typeStatus, setTypeStatus] = useState(true);
  const [createAccount, setCreateAccount] = useState(false);
  const [createAccountValue, setCreateAccountValue] = useState(true);
  const user = useSelector((state) => state?.auth?.user);
  const isCTIEnabledRef = useRef();

  const [enforcePractitionerDOB, setEnforcePractitionerDOB] = useState(false);
  const [enforcePractitionerGender, setEnforcePractitionerGender] = useState(false);
  const [enforcePractitionerAddress, setEnforcePractitionerAddress] = useState(false);
  const [enforcePractitionerCountry, setEnforcePractitionerCountry] = useState(false);
  const [enforcePractitionerProvince, setEnforcePractitionerProvince] = useState(false);
  const [enforcePractitionerCity, setEnforcePractitionerCity] = useState(false);
  const [enforcePractitionerPostal, setEnforcePractitionerPostal] = useState(false);

  //For getting general Practiotioner data and setting the list and options
  // const [generalPractitionerOptions, setGeneralPractitionerOptions] = useState(
  //   []
  // );
  // const [generalPractitionerData, setGeneralPractitionerData] = useState([]);
  const adminOrgs = useSelector((state) => state?.auth?.user?.organizations)

  //Fetching Organization Data
  const onSuccessOrg = (data) => {
    setOrganizations(data?.map((org) => (org = { ...org, value: org?.id })));
    setOrganizationsData(data);
  };
  const { isLoading } = useOrgQuery({ onSuccess: onSuccessOrg });

  //Handle change function for org selection and showing roles w.r.to selected org
  const handleOrgChange = async (event) => {
    const value = event?.target?.value;
    setOrgSelected(true);
    formik.setFieldValue("organization", value);
    const arr = [];
    arr.push(value);
    getCustomRoles(arr)
      .then((res) => {
        setRolesOptions(
          res?.data?.map(
            (role) => (role = { ...role, name: role?.display, value: role?.id })
          )
        );
      })
      .catch((res) => {
        failed(
          res?.response?.data?.message ||
          res?.response?.data?.error ||
          res.message
        );
      });
    setSelectedOrg(value);
    await setCTIstatus(value);
  };

   useEffect(() => {
        if (!selectedOrg) return;
        setLoading(true);
        getOrganizationSettings(selectedOrg)
          .then((res) => {
            if (res?.status) {
              const p = res.data?.practitioner || {};
              setEnforcePractitionerDOB(!!p.dob);
              setEnforcePractitionerGender(!!p.gender);
              setEnforcePractitionerAddress(!!p.address);
              setEnforcePractitionerCountry(!!p.country);
              setEnforcePractitionerProvince(!!p.province);
              setEnforcePractitionerCity(!!p.city);
              setEnforcePractitionerPostal(!!p.postalCode);
            }
          })
          .catch((res) => {
            failed(
              res?.response?.data?.message ||
                res?.response?.data?.error ||
                res.message
            );
          })
          .finally(() => setLoading(false));
      }, [selectedOrg]);

  const setCTIstatus = async(orgId) => {
    //const response = await getDiscover(orgId);
    const response = await getOrganization(orgId)
    isCTIEnabledRef.current = response?.data?.ctiSettings?.enabled;
  }
  //Handle change function for role selection and showing scope of scopeOfPractice w.r.to selected role
  const handleRoleChange = (event) => {
    const value = event?.target?.value;
    formik.setFieldValue("role", value);
    const roleType = rolesOptions.filter((role) => role?.id === value);
    //If type clinical then show scope of Practice
    setRoleSelected( ["clinician", "organizationadministrator"].includes(roleType[0]?.code));
  };
  //Handle change function for Couuntry selection and showing region
  const handleCountryChange = (selectedCountries = []) => {
    let mergedRegions = [];

    if (selectedCountries.includes("CA")) {
      mergedRegions = mergedRegions.concat(caregions);
    }
    if (selectedCountries.includes("US")) {
      mergedRegions = mergedRegions.concat(usregions);
    }

    const deduped = Array.from(
      new Map(mergedRegions.map(r => [r.value, r])).values()
    );
    setRegionOptions(deduped); 
    formik.setFieldValue("scopeOfPractice", []);
  };

  const handleRelationshipChange = (event) => {
    formik.setFieldValue("relationship", event?.target?.value);
  };

  const formik = useFormik({
    ...FormikObjCreate,
      initialValues: {
        ...FormikObjCreate.initialValues,
        type:  "Practitioner",
      },
      validationSchema: Yup.object({
      first_name: conditionalValidation(
        Yup.string()
        .max(50, "Must be 50 characters or less")
        .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
        {
          validation,
          label: "First name",
          mandatory: true
        }
      ),
      last_name: conditionalValidation(
        Yup.string()
          .max(50, "Must be 50 characters or less")
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
        { 
          validation,
          label: "Last name",
          mandatory: true
        }),
              
      qualification: conditionalValidation(
        Yup.string().max(50, "Must be 50 characters or less").matches(
        /^\s*\S[\s\S]*$/,
        "Only blankspaces is not valid."
        ),
        { validation }
      ),
      
      license: conditionalValidation(
          Yup.string().max(20, "Must be 20 characters or less").matches(
          /^\s*\S[\s\S]*$/,
          "Only blankspaces is not valid."
        ),
        { validation }
      ),

      date_of_birth: conditionalValidation(
        Yup.string()
          .nullable()
          .test(
                "valid-format",
                "Invalid format. Use MMM-DD-YYYY (JAN-01-2024).",
                function (value) {
                  if (value) { 
                    const isValid1 = moment(value, "MM/DD/YYYY", true).isValid();
                    const isValid2 = moment(value, "MM-DD-YYYY", true).isValid();
                    if (!isValid1 && !isValid2) return false;
                    const dob = isValid1 ? moment(value, "MM/DD/YYYY") : moment(value, "MM-DD-YYYY"); 
                    if (dob.isAfter(moment())) {
                      return this.createError({
                        message: "Date of birth cannot be in the future.",
                      });
                    } 
                    const age = moment().diff(dob, "years");
                    if (age <= 16) {
                      return this.createError({
                        message: "Age must be greater than 16.",
                      });
                    }
                    let minDate = moment().subtract(125, "years");
                    if (dob.isBefore(minDate)) {
                      return this.createError({
                        message: "Date of Birth cannot be more than 125 years ago.",
                      });
                    }
                  }
                  return true;
                }
              ),
            {
              validation,
              mandatory: enforcePractitionerDOB,
              label: "Date of Birth"
            }),           
        
      phone_number: conditionalValidation(
        Yup.string()
          .matches(
            /^(?:\+?1[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
            "Enter Valid Phone Number."
          ),
          {
            validation,
            label: "Phone Number"
          }
        ),
      home_phone_number: conditionalValidation(
            Yup.string().matches(
              /^(?:\+?1[-. ]?)?\(?[0-9]\d{2}\)?[-. ]?\d{3}[-. ]?\d{4}$/,
              "Enter Valid Home Phone Number."
            ),
            { 
              validation,
              label: "Home Phone Number" 
            }
        ),
      ext: conditionalValidation(
        Yup.string().matches(/^\d{0,4}$/, "Must be 4 digits or less."),
        { validation }
      ),
      address: conditionalValidation(
          Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: enforcePractitionerAddress,
            label: "Address"}),
          
      city: conditionalValidation(
          Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: enforcePractitionerCity,
            label: "City"}),
     
      email: conditionalValidation(
        Yup.string()
            .email("Invalid email address")
            .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
        {
          validation,
          mandatory: true,
          label: "Email"}), 
      
      type: conditionalValidation(
        Yup.string()
           .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
           {
            validation,
            mandatory: true,  
           }
        ),
      
      organization: conditionalValidation(
        Yup.string().matches(
        /^\s*\S[\s\S]*$/,
        "Only blankspaces is not valid."
        ),
        { 
          validation,
          mandatory: true,
          label: "Organization"
        }),

      gender: conditionalValidation(
        Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: enforcePractitionerGender,
            label: "Gender"}),

      country: conditionalValidation(
        Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: enforcePractitionerCountry,
            label: "Country"}),

      region: conditionalValidation(
        Yup.string()
          .matches(/^\s*\S[\s\S]*$/, "Only blankspaces is not valid."),
          {
            validation,
            mandatory: enforcePractitionerProvince}),

      role: conditionalValidation(
        Yup.string().when("type", (type, schema) =>
          typeStatus ? schema.required("Required Role field") : schema
        ),
        {
          validation,
          label: "Role"
        }
      ),
      
      create_account: conditionalValidation(
        Yup.string().when("type", (type, schema) =>
          createAccount ? schema.required("Required Create Account field") : schema),
        {
          validation,
          mandatory: createAccount,
          label: "Create Account"
        }),
      
      scopeOfPractice: conditionalValidation(Yup.array().when("role", (role, schema) =>
          role && roleSelected
            ? schema
                .min(1, "Required scopeOfPractice field")
                .required("Required scopeOfPractice field")
            : schema
        ),
        {
          validation,
          label: "Scope of Practice"
        }), 

      postalCode: Yup.string().when(["type", "country"], (type, country, schema) =>
          conditionalValidation(
            country === "US"
              ? Yup.number()
                .typeError("Zip code must be a number")
              : Yup.string()
                .matches(
                  /^[A-Za-z]\d[A-Za-z] [0-9][A-Za-z]\d$/,
                  "Postal code must be in A1A 1A1 format."
                ),
              {
                validation,
                mandatory: enforcePractitionerPostal,
                label: (country === "US")? "Zip code":"Postal code"})
      ),
      
      hcn: conditionalValidation(
        Yup.string().when("type", (type, schema) =>
          type === "Patient"
            ? schema.required("Patient Identifier is required when creating a patient.")
            : schema
        ),
        {
          validation,
          label:"Patient Identifier"
        }
      ),

      agentId: conditionalValidation(
        Yup.string().matches(/^\S+$/,"Agent Id cannot contain any whitespace"),
        {
          validation,
          label: "Agent Id"
        }),
      }), 
    onSubmit: (values) => {
      values.first_name = values.first_name.trim();
      values.last_name = values.last_name.trim();
      values.email = values.email.trim();
      values.gender = values.gender.trim();
      values.address = values.address.trim();
      values.city = values.city.trim();
      values.country = values.country.trim();
      values.region = values.region.trim();
      values.postalCode = values.postalCode.trim();
      values.qualification = values.qualification.trim();
      values.license = values.license.trim();
      values.agentId = values.agentId.trim();
      const type = rolesOptions.filter((role) => role?.id === values.role);
      const state = values?.region;
      // const generalPractitionersSelected = generalPractitionerData.filter((data) => values?.general_practitioner.includes(data?.id));
      let phoneNumber = createContactNumber(values);
      const dob = encryptData(moment(values?.date_of_birth).format("MM-DD-YYYY"))
      let encryptedData = {
        first_name: encryptData(values?.first_name.toLowerCase()),
        last_name: encryptData(values?.last_name.toLowerCase()),
        full_name: encryptData(
          [
            values?.first_name.toLowerCase(),
            values?.last_name.toLowerCase(),
          ].join(" ")
        ),
        address: encryptData(values?.address),
        date_of_birth: (dob !== "Invalid date") ? dob : "",
        phone_number: encryptData(phoneNumber),
        postalCode: encryptData(values?.postalCode.toUpperCase()),
        city: encryptData(values?.city),
        gender: encryptData(values?.gender),
        email: encryptData(values?.email?.toLowerCase()),
        relationship: encryptData(values?.relationship),
        healthCardNumber: encryptData(values?.hcn),
        device_name: encryptData(values?.device_name),
      };
      
      setBtnLoading(true);
      const selectedLocationData =
        locations?.filter(
          (location) => location?.id === values?.clinic_location
        )?.[0] || null;
      createUser(
        values,
        encryptedData,
        organizationsData,
        state,
        type,
        [],
        selectedLocationData,
        adminOrgs?.[0]?.id
      )
        .then(async (res) => {
          if (res.status === true) {
            console.log("res", res?.data);
            if (values?.agentId){
              const practitionerLink = res?.data?.link[0]?.target?.reference
              const [, practitionerId] = practitionerLink.split("/");
              updateAgentId(practitionerId, values?.agentId)
                .then((res) => {
                  if (res.status === true) {
                    success("Agent ID added successfully");
                  } else {
                    failed("Failed to add Agent ID to practitioner record");
                  }
                })
                .catch((error) => {
                  console.error("Error updating Agent ID:", error);
                });
            }
            navigate("/app/identities/employees");
            success(res.message);
          } else {
            failed(res.error);
          }
        })
        .catch((res) => {
          failed(
            res?.response?.data?.message ||
            res?.response?.data?.error ||
            res.message
          );
        })
        .finally(() => setBtnLoading(false));
    },
  });

 
  const handleCreateAccountChange = useCallback((event) => {
    const value = event?.target?.value; 
    if (value == "true") { 
      setCreateAccountValue(true);
    }
    else{ 
      setCreateAccountValue(false);
    }   
    formik?.setFieldValue("create_account", value);
  }, [formik, setCreateAccountValue]); 

  
  const handleFormChange = (e) => {
    if (e?.target?.id === "region" || e?.target?.id === "organization") {
      const selected_region =
        e?.target?.id === "region" ? e?.target?.value : formik?.values?.region;
      const selected_org =
        e?.target?.id === "organization"
          ? e?.target?.value
          : formik?.values?.organization;
    } else if (e?.target?.id === "country") {
      formik.setFieldValue("region", "");
      formik.setFieldValue("postalCode", "");
    }
  };

  const handlePostalCodeChange = (e) => {
    const { value } = e.target;
    let spacedValue = value;
    if (formik?.values?.country !== "US") {
      // Remove spaces and non-alphanumeric characters
      const formattedValue = value.replace(/[^A-Za-z0-9]/g, "");
      // Add a space after every 3 letters
      spacedValue = formattedValue.replace(
        /^([A-Za-z0-9]{3})([A-Za-z0-9]+)/,
        "$1 $2"
      );
    }
    // Set the formatted value in the formik
    formik?.setFieldValue("postalCode", spacedValue);
  };

  const handleDesignationChange = (event) => {
    const value = event?.target?.value;
    const name = event?.target?.name;
    formik.setFieldValue("designation", value);
  };
  const handleExt = (event) => {
    let key = event.key;
    let regex = new RegExp("^[0-9]+$");
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  };

  const genderOptions = [
      { value: "male", name: "Male" },
      { value: "female", name: "Female" },
      { value: "other", name: "Other" },
  ];

  const createBasicFields = [
      [{
          size: "3",
          fieldType: "TextInput",
          keyField: "first_name",
          label: "First Name",
          placeholder: "First Name",
          required: true,
          hideRequired: false,
      },
      {
          size: "3",
          fieldType: "TextInput",
          keyField: "last_name",
          label: "Last Name",
          placeholder: "Last Name",
          required: true,
          hideRequired: false,
      },{
          fieldType: "ReactDatePicker",
          keyField: "date_of_birth",
          label: "Date of Birth",
          placeholder: "Select Date",
          hasValue: "date_of_birth",
          displayAge: true,
          required: enforcePractitionerDOB,
          hideRequired: !enforcePractitionerDOB,
      },
      {
          fieldType: "SelectFiled",
          keyField: "gender",
          label: "Select Gender",
          options: genderOptions,
          required: enforcePractitionerGender,
          hideRequired: !enforcePractitionerGender,
      },
      ],
      [
          {
              size: "12",
              fieldType: "TextInput",
              keyField: "address",
              label: "Address",
              placeholder: "Address",
              required: enforcePractitionerAddress,
              hideRequired: !enforcePractitionerAddress,
          }
       ],
      [
      {
          size: "6",
          fieldType: "CountrySelect",
          keyField: "country",
          label: "Country",
          required: enforcePractitionerCountry,
          hideRequired: !enforcePractitionerCountry,
      },
      {
          size: "6",
          fieldType: "RegionSelect",
          keyField: "region",
          required: enforcePractitionerProvince,
          hideRequired: !enforcePractitionerProvince,
      }
  ],
  [
      {
          size: "6",
          fieldType: "TextInput",
          keyField: "city",
          label: "City",
          placeholder: "City",
          required: enforcePractitionerCity,
          hideRequired: !enforcePractitionerCity,
      },
      {
          size: "6",
          fieldType: "postalCode",
          required: enforcePractitionerPostal,
          hideRequired: !enforcePractitionerPostal,
      }
  ]
  ];

  return (
    <section className="common-listing">
      <div className="heading-wrap mb-3"> 
      </div>
      <div className="custom-card p-4">
        <form
          className="common-form border-fields userAccount"
          onSubmit={formik.handleSubmit}
          onChange={handleFormChange}
        >
          <Row>
            {isLoading ? (
              <Col>
                <Skeleton animation="wave" />
              </Col>
            ) : (
              <Col md={3}>
                {formik?.values?.type !== "Super-Admin" ? (
                  <SelectFiled
                    keyField={"organization"}
                    label={"Select Organization"}
                    formik={formik}
                    options={organizations}
                    onChange={handleOrgChange}
                  />
                ) : null}
              </Col>
            )}
            <Col>
                  <SelectFiled
                    keyField={"role"}
                    label={"Role"}
                    formik={formik}
                    options={rolesOptions}
                    readOnly={!typeStatus || !orgSelected}
                    onChange={handleRoleChange}
                  />
                </Col>
            { createAccount ? (
              <>
                <Col>
                  <SelectFiled
                    keyField={"create_account"}
                    label={"Create Account"}
                    formik={formik}
                    placeholder={"Create Account"}
                    options={createAccountOptions}
                    onChange={handleCreateAccountChange}
                  />
                </Col>
                
              </>
            ) : (
              <>
                <Col></Col>
                <Col></Col>
              </>
            )}
            <Col style={{display:"flex", placeContent: "flex-end"}}>
                  <Tooltip style={{}}>
                    <div
                      style={{ marginRight: "1rem", cursor: "pointer",maxHeight: "24px" }}
                      onClick={() => navigate(-1)}
                    >
                      <Clear />
                    </div>
                  </Tooltip>
            </Col>
          </Row>
          <Fields fields={createBasicFields} formik={formik} isReadOnly={false} handlePostalCodeChange={handlePostalCodeChange}   />
          <Row>
            <Col  sm lg = "4">
              <TextInput
                keyField={"email"}
                label={"Email Address"}
                formik={formik}
                placeholder={"Email Address"}  
                hideRequired= {!createAccountValue}
                required={true}
              />
            </Col>
                    <Col>
                      <TextInput
                        keyField={"phone_number"}
                        type="phone"
                        label={"Work Phone Number"}
                        formik={formik}
                        placeholder={"Work Phone Number"}
                        hideRequired= {true}
                      />
                    </Col>

                    {formik.values.phone_number && (
                      <Col  sm lg = "2">
                        <TextInput
                          keyField={"ext"}
                          label={"Ext."}
                          type="text"
                          maxlength="4"
                          formik={formik}
                          placeholder={"Ext."}
                          onKeyPress={handleExt}
                          autocomplete="off"
                          hideRequired= {true}
                        />
                      </Col>
                    )}

                    <Col>
                      <TextInput
                        keyField={"home_phone_number"}
                        type="phone"
                        label={"Home Phone Number"}
                        formik={formik}
                        placeholder={"Home Phone Number"}
                        hideRequired= {true}
                      />
                    </Col>
          </Row>
          {roleSelected ? <> 
             <Fields fields={createBasicFieldsPractionerTwo} formik={formik} isReadOnly={false} handlePostalCodeChange={handlePostalCodeChange} />
          </> : null}  
            <Row  style={{ borderTop: "1px solid rgba(0,0,0,0.14)", marginTop: 12, paddingTop: 12 }}>
              <Row style={{ fontWeight: "bold", marginBottom: 15, fontSize: 18 }}>Scope of Practice</Row>
              <Col xs lg="3">
                <MultiSelect
                  options={countryList}
                  keyField={"countryList"}
                  formik={formik}
                  isSelectAllEnable={true}
                  label={"Country"}
                  style={{width: "100%"}}
                  bindMethod={handleCountryChange}
                  required={enforcePractitionerCountry}
                />
              
              </Col>
              <Col>
                <MultiSelect
                  options={regionOptions}
                  keyField={"scopeOfPractice"}
                  formik={formik}
                  isSelectAllEnable={true}
                  label={"Province/State"}
                  style={{width: "100%"}}
                  required={enforcePractitionerProvince}
                  hideRequired={false}
                />
              </Col> 
            </Row>  
            <Row  style={{ borderTop: "1px solid rgba(0,0,0,0.14)", marginTop: 12, paddingTop: 12 }}>
               {isCTIEnabledRef.current && (
                <Col>
                  <TextInput
                    keyField={"agentId"}
                    label={"Agent ID"} 
                    formik={formik}
                    placeholder={"Agent ID"}
                    tooltip={"User identifier from telephony agent"}
                    hideRequired={true}
                  />
                </Col>
              )}
              <Col></Col>
              <Col></Col>
            </Row> 

          <div className="btn-wrap" style={{ display: "flex", gap: "16px" }}>
            <Button type="submit" isLoading={btnLoading}>
              Create
            </Button>
            <Button
              onClick={() => navigate("/app/identities/employees")}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </section>
  );
}

export default CreateEmployee;
